// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a.enjoy-rewards_DkVvV{text-decoration:none;color:#272525;cursor:pointer;border-bottom:1px solid transparent;font-size:14px}a.enjoy-rewards_DkVvV.mobile_3TXbC{display:flex;align-items:center;margin-bottom:5px;border:none;width:100%;padding:9px 15px 9px 29px;color:#63666a;min-height:40px;font-size:18px;font-weight:300;line-height:normal}a.enjoy-rewards_DkVvV.mobile_3TXbC:hover{border:none}a.enjoy-rewards_DkVvV:hover{text-decoration:none;border-bottom:1px solid}.enjoy-rewards-available-balance_2kG9u{background-color:#272525;color:#fff;padding:0 9px;border-radius:20px;font-weight:600;margin-left:10px}", ""]);
// Exports
exports.locals = {
	"enjoy-rewards": "enjoy-rewards_DkVvV",
	"mobile": "mobile_3TXbC",
	"enjoy-rewards-available-balance": "enjoy-rewards-available-balance_2kG9u"
};
module.exports = exports;
